// extracted by mini-css-extract-plugin
export var chip = "_dk-0";
export var filterDropdown = "_dk-5";
export var filterItem = "_dk-6";
export var icon = "_dk-1";
export var removeButton = "_dk-3";
export var removeIcon = "_dk-4";
export var separator = "_dk-2";